import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import PageStructure from 'flarum/forum/components/PageStructure';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import ItemList from 'flarum/common/utils/ItemList';
import PollView from './PollView';
import PollPageHero from './PollPageHero';
export default class PollViewPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", false);
    _defineProperty(this, "poll", null);
  }
  oninit(vnode) {
    super.oninit(vnode);
    if (!app.forum.attribute('globalPollsEnabled')) {
      m.route.set('/');
      return;
    }
    const editId = m.route.param('id');
    this.poll = app.store.getById('poll', editId);
    if (!this.poll) {
      this.loading = true;
      app.store.find('polls', editId).then(item => {
        this.poll = item;
        this.loading = false;
        app.current.set('poll', item);
        app.setTitle(this.poll.question());
        m.redraw();
      });
    }
  }
  view() {
    return m(PageStructure, {
      className: "PollViewPage",
      hero: this.hero.bind(this),
      sidebar: this.sidebar.bind(this),
      loading: this.loading
    }, this.contentItems().toArray());
  }
  hero() {
    return m(PollPageHero, null);
  }
  sidebar() {
    return m(IndexSidebar, null);
  }
  contentItems() {
    const items = new ItemList();
    if (this.poll) {
      items.add('poll', m(PollView, {
        poll: this.poll
      }));
    }
    return items;
  }
}
flarum.reg.add('fof-polls', 'forum/components/PollViewPage', PollViewPage);